export class ActiveWidget {

    public editCallback: () => void;

    private removeCallback: () => void;

    private refreshCallback: () => void;

    /**
     * Provide the edit callback.
     *
     * @param {() => void} callback
     */
    public setEdit(callback: () => void) {
        this.editCallback = callback;
    }

    /**
     * Execute the edit callback.
     */
    public edit() {
        if (this.editCallback) {
            this.editCallback();
        }
    }

    /**
     * Provide the remove callback.
     *
     * @param {() => void} callback
     */
    public setRemove(callback: () => void) {
        this.removeCallback = callback;
    }

    /**
     * Execute the remove callback.
     */
    public remove() {
        if (this.removeCallback) {
            this.removeCallback();
        }
    }

    /**
     * Provide the refresh callback.
     *
     * @param {() => void} callback
     */
    public setRefresh(callback: () => void) {
        this.refreshCallback = callback;
    }

    /**
     * Execute the refresh callback.
     */
    public refresh() {
        if (this.refreshCallback) {
            this.refreshCallback();
        }
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/classes/active-widget.ts